import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { ModalMobileTabs } from './modalMobileTab';
import { ModalContent } from '../layout/modal/content';
import { useTranslation } from 'react-i18next';
import { IoMdClose } from 'react-icons/io';
import { FORMATS, OrderUtils, SortType } from '@lib/common';
import moment from 'moment';
import { FaAngleDown, FaAngleUp, FaMapMarker } from 'react-icons/fa';
import { OrderTotals } from '../order/order-totals';
import { OrderItems } from '../order/order-items';
import { Tag } from '../elements/tag';
import { IconCircle } from '../elements/icon.circle/index2';
import { OrderIcon } from '../order/order-icon';
import { LinkTag } from '../elements/link';
import Big from 'big.js';
import _get from 'lodash/get';
const DetailOrderCardWrapper = styled.div `
  font-family: Inter;
  position: fixed;
  background: #fff;
  z-index: 11;
  bottom: 0;
  right: 0;
  transition: 0.25s;
  ${({ isOpen }) => isOpen
    ? css `
          height: 100%;
          width: 100%;
        `
    : css `
          height: 0;
          *,
          div {
            display: none;
          }
        `}
`;
const DetailOrderHeader = styled.div `
  display: flex;
  padding: 8px 16px;
  justify-content: space-between;
  align-items: center;
  font-family: Inter;
`;
const OrderStyle = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  color: #0c202a;
`;
const StatusStyle = styled.div `
  display: flex;
  padding: 4px 12px;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  border-radius: 99px;
  background-color: #009100;
  color: #fff;
`;
const EstimatedTimeStyle = styled.div `
  font-style: normal;
  font-weight: 600;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
  flex: 1 0 0;
`;
const OrderInfoWrapper = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
`;
const DetailTabStyle = styled.div `
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  flex: 1 0 0;
  align-self: stretch;
  height: calc(100vh - 312px);
  overflow: scroll;
`;
const OrderInfo = styled.div `
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
`;
const TitleInfo = styled.div `
  height: 24px;
  min-width: 148px;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  color: #6b7270;
  margin-right: 16px;
  display: flex;
  align-items: center;
`;
const NumberTag = styled.span `
  border-radius: 50%;
  background: #eaeaea;
  padding: 5px;
  min-width: 20px;
  font-size: 11px;
  text-align: center;
  font-weight: 600;
`;
const ActionButtonWrapper = styled.div `
  position: fixed;
  bottom: 0;
  width: 100%;
  display: flex;
  padding: 8px 16px;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  border-top: 1px solid #dfdfdf;
  background: #fff;
`;
const ChangeStatusButton = styled.div `
  display: flex;
  min-width: 226px;
  background-color: #fb2f2f;
  color: #fff;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  padding: 12px;
`;
const CancelButton = styled.div `
  background-color: #f1f4f7;
  color: #4b4f5e;
  min-width: 114px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
`;
const DeliveryTracking = styled.div `
  display: flex;
  padding: 8px 16px;
  align-items: center;
  gap: 4px;
  background-color: #fb2f2f;
  color: #fff;
  border-radius: 4px;
`;
const MoreActionButtonWrapper = styled.div `
  text-align: center;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
const MoreActionButton = styled.div `
  display: flex;
  width: 396px;
  padding: 12px 16px;
  align-items: center;
  height: 64px;
  justify-content: center;
  border-radius: 4px;
  ${({ isDeleteButton }) => isDeleteButton
    ? css `
          background-color: #bc362f;
          color: #fefefe;
        `
    : css `
          background-color: #f5f5f5;
          color: #4b4f5e;
        `}
`;
const DeliveryAddressStyle = styled.div `
  display: flex;
  padding: 8px 16px;
  align-items: center;
  gap: 4px;
  border-radius: 4px;
  justify-content: center;
  border: 1px solid #4b4f5e;
  color: #4b4f5e;
  font-weight: 700;
  width: 123px;
`;
const DetailOrderInfo = styled.div `
  display: flex;
  align-items: center;
  font-weight: 500;
`;
export const DetailOrderCard = ({ isOpen, close, order, hidePrices, timezones, rates, uom, conversionNumber, status, mapData, }) => {
    const [tab, setTab] = useState(0);
    const [openOrderInfoPart, setOpenOrderInfoPart] = useState(true);
    const [openDeliveryPart, setOpenDeliveryPart] = useState(true);
    const [openCustomerPart, setOpenCustomerPart] = useState(true);
    const [changeOrderStatus, setChangeOrderStatus] = useState(false);
    const [openMoreAction, setOpenMoreAction] = useState(false);
    const handleOpenOrderInfo = () => {
        setOpenOrderInfoPart(preState => !preState);
    };
    const handleOpenDelivery = () => {
        setOpenDeliveryPart(preState => !preState);
    };
    const handleOpenCustomer = () => {
        setOpenCustomerPart(preState => !preState);
    };
    const handleChangeOrderStatus = () => {
        setChangeOrderStatus(true);
    };
    const handleOpenMoreAction = () => {
        setOpenMoreAction(true);
    };
    const { date, time } = order.config;
    const handleTabChange = (selectedTab) => {
        setTab(selectedTab.value);
    };
    const { t } = useTranslation();
    const log = order.log;
    const orderLogTitles = {
        status_update: 'Update Status',
        due_update: 'Update Due Time',
        print_request: 'Print Request',
        tookan_book: 'Book Delivery Tookan',
        uber: 'Uber Update',
        refunded: 'Refunded',
    };
    const formatDate = (dateString) => {
        const dateObj = new Date(dateString);
        const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        const monthsOfYear = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        const dayOfWeek = daysOfWeek[dateObj.getDay()];
        const month = monthsOfYear[dateObj.getMonth()];
        const day = dateObj.getDate();
        const year = dateObj.getFullYear();
        const formattedDate = `${dayOfWeek}, ${month} ${day}, ${year}`;
        return formattedDate;
    };
    const getEsitmatedTime = (timestamp) => {
        const dateObj = new Date(timestamp);
        const hours = dateObj.getHours();
        const minutes = dateObj.getMinutes();
        const ampm = hours >= 12 ? 'PM' : 'AM';
        const formattedHours = hours % 12 || 12;
        const currentTime = `${formattedHours}:${minutes} ${ampm}`;
        return currentTime;
    };
    const today = new Date();
    const ampm = today.getHours() >= 12 ? 'PM' : 'AM';
    const currentHours = (today.getHours() % 12) +
        ':' +
        (today.getMinutes() < 10 ? '0' + today.getMinutes() : today.getMinutes()) +
        ' ' +
        ampm;
    const checkDue = () => {
        if (order.config.due === 'now') {
            return 'Now / ASAP';
        }
        const timestamp = moment.tz(`${date} ${time}`, FORMATS.moment.datetime, timezones).valueOf();
        return t('datetimeFromTimestamp', {
            value: timestamp,
        });
    };
    const checkDeliveryTracking = () => {
        if (OrderUtils.hasDeliveryError(order)) {
            return React.createElement("span", { className: "error-text" }, "Failed to book delivery");
        }
        const trackingUrl = OrderUtils.getTrackingUrl(order);
        const returnTrackingUrl = OrderUtils.getReturnTrackingUrl(order);
        const deliveryStatus = OrderUtils.getDeliveryStatusFromProvider(order);
        if (order.status !== 'cancelled') {
            return (React.createElement(React.Fragment, null, trackingUrl && (React.createElement(DeliveryTracking, null,
                React.createElement("a", { href: trackingUrl },
                    React.createElement(OrderIcon, { service: order.config.service }),
                    " Track Delivery")))));
        }
        if (returnTrackingUrl && order.status === 'cancelled') {
            return (React.createElement("span", null,
                "Cancelled delivery (Track",
                ' ',
                React.createElement(LinkTag, { target: "_blank", href: trackingUrl }, "Return Delivery"),
                ")"));
        }
        return null;
    };
    const checkDeliveryAddress = () => {
        let directions = null;
        const oc = order.config;
        if (mapData.type !== 'custom') {
            const directionsUrl = `https://www.google.com/maps/dir/?api=1&origin=${mapData.lat},${mapData.lng}&destination=${oc.lat},${oc.lng}`;
            directions = (React.createElement(DeliveryAddressStyle, null,
                React.createElement("a", { href: directionsUrl, target: "_blank" },
                    React.createElement(FaMapMarker, null),
                    " Directions")));
        }
        return (React.createElement("span", null, directions));
    };
    let checkoutFields = _get(order, 'checkout_fields');
    const checkContactlessDelivery = (checkoutFields) => {
        const desiredLabel = "Request No Contact Delivery";
        const desiredField = checkoutFields ? checkoutFields.find((field) => field.question.label === desiredLabel) : false;
        if (desiredField) {
            const desiredAnswer = desiredField.answer;
            if (desiredAnswer === "no") {
                return React.createElement("div", { style: { color: '#fb2f2f' } }, "No Requested");
            }
            else if (desiredAnswer === "yes") {
                return React.createElement("div", { style: { color: '#51A351' } }, "Requested");
            }
        }
        return React.createElement("div", { style: { color: 'red' } }, " No Requested");
    };
    return (React.createElement(DetailOrderCardWrapper, { isOpen: isOpen },
        React.createElement(DetailOrderHeader, null,
            React.createElement("div", { style: { display: 'flex' } },
                React.createElement("div", null,
                    React.createElement(IconCircle, { size: 28, iconSizeModifier: 12, icon: React.createElement(OrderIcon, { service: order.config.service, deliveryProvider: order.config.delivery_provider }), background: 'red' })),
                React.createElement(OrderStyle, { className: "m-lr-2" }, order.number),
                React.createElement(StatusStyle, null, status)),
            React.createElement("div", { style: { display: 'flex' } },
                React.createElement(IoMdClose, { size: 24, onClick: close }))),
        React.createElement("div", { style: { display: 'flex', gap: '24px', padding: '16px' } },
            React.createElement("img", { src: "/images/cooking/cook.gif", width: "128px", height: "128px" }),
            React.createElement(EstimatedTimeStyle, null,
                React.createElement("div", { style: { fontSize: '16px', lineHeight: '24px' } }, "Estimated Ready Time"),
                React.createElement("div", { style: { fontSize: '42px', lineHeight: '42px' } }, currentHours),
                React.createElement("div", { style: { fontSize: '16px', lineHeight: '24px' } }, formatDate(new Date())))),
        React.createElement(ModalMobileTabs, { value: tab, onChange: handleTabChange, tabs: [
                { label: 'Details', value: 0 },
                { label: 'Items', value: 1 },
                { label: 'Log', value: 2 },
            ] }),
        tab === 0 && (React.createElement(DetailTabStyle, null,
            React.createElement(OrderInfoWrapper, null,
                React.createElement("div", { onClick: handleOpenOrderInfo, style: { display: 'flex', justifyContent: 'space-between', width: '100%', cursor: 'pointer' } },
                    React.createElement("div", { style: { fontSize: '16px', fontWeight: 700 } }, "Order Info"),
                    React.createElement("div", null, openOrderInfoPart ? React.createElement(FaAngleDown, null) : React.createElement(FaAngleUp, null))),
                openOrderInfoPart && (React.createElement(OrderInfo, null,
                    React.createElement("div", { style: { display: 'flex' } },
                        React.createElement(TitleInfo, null, "Placed"),
                        React.createElement(DetailOrderInfo, null, t('datetimeFromTimestamp', {
                            value: order.created,
                        }))),
                    React.createElement("div", { style: { display: 'flex' } },
                        React.createElement(TitleInfo, null, "Due"),
                        React.createElement(DetailOrderInfo, null, checkDue())),
                    React.createElement("div", { style: { display: 'flex' } },
                        React.createElement(TitleInfo, null, "Type"),
                        React.createElement(DetailOrderInfo, null, t(`constants.services.${order.config.service}`))),
                    React.createElement("div", { style: { display: 'flex' } },
                        React.createElement(TitleInfo, null, "Contactless Delivery"),
                        React.createElement(DetailOrderInfo, null, checkContactlessDelivery(checkoutFields))),
                    React.createElement("div", { style: { display: 'flex' } },
                        React.createElement(TitleInfo, null, "Payment Method"),
                        React.createElement(DetailOrderInfo, null, order.payment.method))))),
            order.config.service === 'delivery' && (React.createElement(OrderInfoWrapper, null,
                React.createElement("div", { onClick: handleOpenDelivery, style: { display: 'flex', justifyContent: 'space-between', width: '100%', cursor: 'pointer' } },
                    React.createElement("div", { style: { fontSize: '16px', fontWeight: 700 } }, "Delivery"),
                    React.createElement("div", null, openDeliveryPart ? React.createElement(FaAngleDown, null) : React.createElement(FaAngleUp, null))),
                openDeliveryPart && (React.createElement(OrderInfo, null,
                    React.createElement("div", { style: { display: 'flex' } },
                        React.createElement(TitleInfo, null, "Courier"),
                        React.createElement(DetailOrderInfo, null, order.config.delivery_provider)),
                    React.createElement("div", { style: { display: 'flex' } },
                        React.createElement(TitleInfo, null, "Delivery Tracking URL"),
                        React.createElement(DetailOrderInfo, null, checkDeliveryTracking())),
                    React.createElement("div", { style: { display: 'flex' } },
                        React.createElement(TitleInfo, null, "Delivery Address"),
                        React.createElement("div", { style: { display: 'flex', flexDirection: 'column' } },
                            React.createElement(DetailOrderInfo, null, order.config.destination),
                            React.createElement(DetailOrderInfo, null, checkDeliveryAddress()))),
                    React.createElement("div", { style: { display: 'flex' } },
                        React.createElement(TitleInfo, null, "Estimated Time"),
                        React.createElement(DetailOrderInfo, null, order.delivery_in && getEsitmatedTime(order.delivery_in.timestamp))),
                    React.createElement("div", { style: { display: 'flex' } },
                        React.createElement(TitleInfo, null, "Arrival Date"),
                        React.createElement(DetailOrderInfo, null, order.delivery_in && formatDate(order.delivery_in.timestamp))),
                    React.createElement("div", { style: { display: 'flex' } },
                        React.createElement(TitleInfo, null, "Delivery Status"),
                        React.createElement(DetailOrderInfo, null,
                            "For ",
                            status)),
                    React.createElement("div", { style: { display: 'flex' } },
                        React.createElement(TitleInfo, null, "Distance"),
                        React.createElement(DetailOrderInfo, null,
                            order.config.distance ? Big(order.config.distance / conversionNumber).toFixed(3) : 0,
                            uom)),
                    React.createElement("div", { style: { display: 'flex' } },
                        React.createElement(TitleInfo, null, "Driving Time"),
                        React.createElement(DetailOrderInfo, null,
                            order.config.driving_time ? Big(order.config.driving_time / 60).toFixed(2) : 0,
                            " mins")))))),
            React.createElement(OrderInfoWrapper, null,
                React.createElement("div", { onClick: handleOpenCustomer, style: { display: 'flex', justifyContent: 'space-between', width: '100%', cursor: 'pointer' } },
                    React.createElement("div", { style: { fontSize: '16px', fontWeight: 700 } }, "Customer"),
                    React.createElement("div", null, openCustomerPart ? React.createElement(FaAngleDown, null) : React.createElement(FaAngleUp, null))),
                openCustomerPart && (React.createElement(OrderInfo, null,
                    React.createElement("div", { style: { display: 'flex' } },
                        React.createElement(TitleInfo, null, "Name"),
                        React.createElement(DetailOrderInfo, null, order.customer.name)),
                    React.createElement("div", { style: { display: 'flex' } },
                        React.createElement(TitleInfo, null, "Email"),
                        React.createElement(DetailOrderInfo, null, order.customer.email)),
                    React.createElement("div", { style: { display: 'flex' } },
                        React.createElement(TitleInfo, null, "Contact Number"),
                        React.createElement(DetailOrderInfo, null, order.customer.phone))))))),
        tab === 1 && (React.createElement(ModalContent, { paddinglr: 20, paddingtb: 15, style: { height: `calc(100vh - 312px)`, overflow: 'scroll' } },
            React.createElement(OrderItems, { items: order.dishes, renderDetails: {
                    enabled: true,
                    prices: !hidePrices,
                    option_prices: !hidePrices,
                    combo_choice_names: true,
                    disable_print_name: true,
                    sort_type: SortType.ByCart.toString(),
                } }),
            !hidePrices && (React.createElement(OrderTotals, { tax_in_prices: order.bill.tax_in_prices, fees: order.bill.fees || [], taxes: order.bill.taxes || [], discount: order.bill.discount, promo: null, totalCart: order.bill.cart, total: order.bill.total, tip: typeof order.bill.tip === 'undefined' ? 0 : order.bill.tip })),
            rates.map((rate, index) => {
                {
                    return rate.tax_indicator_flag ? (React.createElement("p", { key: index, className: "small", style: {
                            marginTop: '10px',
                        } }, rate.tax_indicator_string)) : (React.createElement("div", { key: index }));
                }
            }))),
        tab === 2 && (React.createElement(ModalContent, { paddinglr: 20, paddingtb: 20, style: { height: `calc(100vh - 312px)`, overflow: 'scroll' } },
            !!(!log || log.length === 0) && React.createElement("p", { className: "text-center p-tb-8 big" }, "No log entries..."),
            !!(log && log.length > 0) && (React.createElement("div", { className: "" },
                React.createElement("p", { className: "m-b-3 p-b-3 border-white-b-15 small1" }, "Sorted from newest to oldest"),
                log.map(({ user, timestamp, data }, i) => {
                    return (React.createElement("div", { key: i, className: i === 0 ? '' : 'm-t-3 p-t-3 border-white-dash-t-15' },
                        React.createElement("div", { style: {
                                marginBottom: '7px',
                            }, className: "flex-line centered" },
                            React.createElement(NumberTag, { className: "m-r-2" }, log.length - i),
                            React.createElement("p", { className: "font-semi-bold uppercase small", style: {
                                    color: '#838383',
                                } }, orderLogTitles[data.type])),
                        React.createElement("p", { className: "lhp" },
                            data.type === 'status_update' &&
                                `Updated from "${t(`order.status.${data.from}`)}" to "${t(`order.status.${data.to}`)}"`,
                            data.type === 'due_update' &&
                                order.config.service === 'delivery' &&
                                `Delivery time updated to "${t(`datetimeFromTimestamp`, {
                                    value: data.due,
                                })}"`,
                            data.type === 'due_update' &&
                                order.config.service !== 'delivery' &&
                                `Ready time updated to "${t(`datetimeFromTimestamp`, {
                                    value: data.due,
                                })}"`,
                            data.type === 'print_request' && `Print request sent to printer "${data.printer}"`,
                            data.type === 'tookan_book' &&
                                (data.success
                                    ? 'Successfully booked delivery job with Tookan'
                                    : 'Failed to book delivery job with Tookan'),
                            data.type === 'uber' && `${data.message}`),
                        React.createElement("div", { className: "m-t-2" },
                            React.createElement(Tag, { className: "m-r-2" }, t(`datetimeFromTimestamp`, {
                                value: timestamp,
                            })),
                            React.createElement(Tag, { className: "small" }, user === 'system' ? 'System' : user))));
                })))))));
};
//# sourceMappingURL=detail-order.js.map